import React from 'react'

const Checkboxes = ({ content, onSelected, getVariable }) => {
    let c = content;
    let onChecked = (event) => {
        let id = event.target.name;
        let value = event.target.checked;
        onSelected(id, { text: value });
    }
    let onChange2 = (event) => {
        let id = event.target.name;
        let value = event.target.checked ? true: false;
        onSelected(id, { text: value });
    }
    let onIconClick = (event) => {
    }

    var cur_icon;

    return (
        <div className="question question-content" key={c.title}>
           <h3 className={c.style + " selected"}>{c.title}</h3>
           <p>{c.text}</p>
            {c.choices.map((o) => {
                if(getVariable((c.id + "_" + o.value)) == true) {
                    return(
                    <div key={o.text} className='form-check form-switch form-switch-sm'>
                        <input type="checkbox" className={c.style + " form-check-input"} id={(c.id + "_" + o.value)} name={(c.id + "_" + o.value)} value={o.value} onChange={onChange2} checked />
                        <label className='form-check-label' htmlFor={o.text}>
                            <h5 style={{paddingTop:"5px", paddingLeft:"8px", margin:"0"}}>{o.text}</h5>
                        </label>
                        <a onClick={onIconClick} style={{width:"7%", float:"right", cursor:"pointer"}}><img style={{width:"100%", float:"right"}} src={cur_icon}/></a>
                    </div>
                    )
                } else {
                    return(
                        <div key={o.text} className='form-check form-switch form-switch-sm'>
                            <input type="checkbox" className={c.style + " form-check-input"} id={(c.id + "_" + o.value)} name={(c.id + "_" + o.value)} value={o.value} onChange={onChange2} />
                            <label className='form-check-label' htmlFor={o.text}>
                                <h5 style={{paddingTop:"5px", paddingLeft:"8px", margin:"0"}}>{o.text}</h5>
                            </label>
                            <a onClick={onIconClick} style={{width:"7%", float:"right", cursor:"pointer"}}><img style={{width:"100%", float:"right"}} src={cur_icon}/></a>
                        </div>
                    )
                }
            })}
        </div>
    )
};

export default Checkboxes